module.exports = __webpack_public_path__ + "img/stock-photo_woman-with-phone.dd99f655.jpg";